export default "__VITE_ASSET__CpCdqrYF__"